/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { UploadedItem } from '../../models/uploaded-item';

export interface MediaControllerUploadFile$Params {
      body: {
'file'?: Blob;
'prefix'?: string;
'fileName'?: string;
}
}

export function mediaControllerUploadFile(http: HttpClient, rootUrl: string, params: MediaControllerUploadFile$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UploadedItem;
}>> {
  const rb = new RequestBuilder(rootUrl, mediaControllerUploadFile.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: UploadedItem;
      }>;
    })
  );
}

mediaControllerUploadFile.PATH = '/file-manager';
